import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router'
import { trackPageView } from '@/composables/useAnalytics'
import { applySeo } from '@/composables/useSeo'
import { SITE_DESCRIPTION, SITE_TITLE } from '@/config/site'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      title: SITE_TITLE,
      description: SITE_DESCRIPTION,
    },
  },
  {
    path: '/play/:modeId',
    name: 'play',
    component: () => import('@/views/GameView.vue'),
    meta: {
      title: 'FpsTrain · 训练中',
      description: '正在进行 FPS 枪法训练，专注甩枪与连击。',
      noindex: true,
    },
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('@/views/ResultView.vue'),
    meta: {
      title: 'FpsTrain · 训练结果',
      description: '查看本局得分、命中率与高光回放。',
      noindex: true,
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/SettingsView.vue'),
    meta: {
      title: 'FpsTrain · 灵敏度设置',
      description: '配置 DPI、cm/360 与音频，匹配你的 FPS 游戏手感。',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.afterEach((to) => {
  applySeo({
    title: (to.meta.title as string) || SITE_TITLE,
    description: to.meta.description as string | undefined,
    path: to.path,
    noindex: Boolean(to.meta.noindex),
  })
  trackPageView(`${window.location.pathname}#${to.fullPath}`)
})
